+function($, window, document) {
	var scope;
	
	var BackTop = function(element, options) {
		this.$element = $(element);
		this.$window = $(window);
		this.options = options;
		
		this.initialize();
	};
	
	BackTop.DEFAULTS = {
		minScrollTop: 400,
		fadeSpeed: 200
	};
	
	BackTop.prototype.initialize = function() {
		scope = this;

		this.observeScroll();
		this.observeClick();
	};

	BackTop.prototype.observeClick = function() {
		if (detectMobile()) {
			var hammer = new Hammer(this.$element[0]);

			hammer.on('tap', function(event) {
				$.scrollTo(0);
			});
		}else {
			this.$element.on('click', function() {
				$.scrollTo(0);
			});
		}
	};	

	BackTop.prototype.observeScroll = function() {
		this.$window.scroll(function() {
			if(scope.$window.scrollTop() >= scope.options.minScrollTop)
			{
				scope.$element.fadeIn(scope.options.fadeSpeed);
			}
			else
			{
				scope.$element.fadeOut(scope.options.fadeSpeed);
			}
		});
	};
	
	function Plugin(option) {
		var $this   = $(this),
			data   	= $this.data('sn.Backtop'),
			options = $.extend({}, BackTop.DEFAULTS, typeof option == 'object' && option);
		  
		if ( ! data) {
			$this.data('sn.Backtop', (data = new BackTop(this, options)));  
		} 
		  
		if (typeof option == 'string') {
			data[option]();  
		} 
	}
	
	$.fn.backTop = Plugin;
	$.fn.backTop.Constructor = BackTop;
			
	//data-api
	$(function() {
		$('[data-toggle="backtop"]').each(function () {
			var $element = $(this);
		  
			Plugin.call($element, $element.data())
		});
	})
}(jQuery, window, document);